import { useMutation, useQuery } from "@tanstack/react-query";
import { useClient } from "../context/auth-context";
import { generateMetaData } from "../util";
import { useIpDetails } from "./location-service";
import { parseApiResponse } from "../models";
import { fetchServiceJson, toPlainObject } from "./service-fetch";

export async function fetchPublicEventByNo(id, token) {
  if (!id) return {};

  try {
    const response = await fetchServiceJson(`event/public/no/${id}/info`, token);
    return response ? toPlainObject(parseApiResponse(response)) : {};
  } catch (err) {
    console.log({ err });
    return {};
  }
}

export function useFreeTicketRegister({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) =>
      client(`event/${params.eventId}/user/${params.userId}/ticket/register`, {
        data: {
          ...params,
          ...generateMetaData(data),
        },
      }).then(parseApiResponse),
    {
      ...config,
    },
  );
}

export function usePublicFreeTicketRegister({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) =>
      client(`event/public/${params.eventId}/register`, {
        data: {
          ...params,
          ...generateMetaData(data),
        },
      }).then(parseApiResponse),
    {
      ...config,
    },
  );
}

export function usePaidTicketRegister({ ...config }) {
  const client = useClient();
  const { data } = useIpDetails();
  return useMutation(
    (params) => {
      const requestConfig = {
        data: {
          ...params,
          ...generateMetaData(data),
        },
      };
      if (params.token) {
        requestConfig.headers = {
          Authorization: `Bearer ${params.token}`,
        };
      }
      return client(`event/${params.eventId}/payment/init`, requestConfig);
    },
    {
      ...config,
    },
  );
}

export function useGetEvent({ ...config }) {
  const client = useClient();
  return useMutation(
    (params) =>
      client(`event/public/${params.eventId}/info`, {}).then(
        parseApiResponse,
      ),
    {
      ...config,
    },
  );
}

export function usePublicEvents({
  search,
  limit,
  page,
  token,
  ...config
}) {
  const client = useClient();
  return useQuery(
    [search, page],
    () =>
      client(
        search
          ? `event/public/events?searchTerm=${search}&limit=${limit}&page=${page}`
          : `event/public/events?limit=${limit}&page=${page}`,
      ).then((response) => parseApiResponse(response).data),
    {
      enabled: !!token,
      ...config,
    },
  );
}
